import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { NO_IMAGE } from 'utils/constants';

import ScribeLink from 'apps/scribe/ScribeLink';

/*
"NO_IMAGE"  is used when in "Top Tab"
we are mixed text and images or use only text
*/
const TopTabs = ({ betaFeatures, items, reportTopTabClicked }) => {
  if (!items.length) {
    return null;
  }

  const handleClick = (link, name) => (event) => {
    if (typeof reportTopTabClicked === 'function') {
      event.preventDefault();
      reportTopTabClicked(link, name);
    }
  };

  const listItems = items
    .filter(item => !item.betaFeatureName || betaFeatures.includes(item.betaFeatureName))
    .map((item) => (

      <li
        // (list is static and would never be reordered, use array index)
        // eslint-disable-next-line react/no-array-index-key
        key={item.name}
        className={classNames(
          'hd-topTabs__item',
          `hd-topTabs__item--${item.name}`
        )}
      >
        <ScribeLink
          className={classNames(
            'hd-topTabs__link',
            { 'hd-topTabs__link--noImage': !item.imageUrl },
          )}
          to={item.link}
          onClick={handleClick(item.link, item.name)}
        >
          {!item.imageUrl.includes(NO_IMAGE) ? (
            <img
              className="hd-topTabs__img"
              src={item.imageUrl}
              alt={item.text}
              title={item.text}
            />
          ) : (
            <span className="hd-topTabs__text">{item.text}</span>
          )}
        </ScribeLink>
      </li>
    ));

  return (
    <div className="hd-topTabs">
      <ul className="hd-topTabs__list">
        {listItems}
      </ul>
    </div>
  );
};

TopTabs.propTypes = {
  betaFeatures: PropTypes.array.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      imageUrl: PropTypes.string,
      text: PropTypes.string,
      link: PropTypes.string,
      betaFeatureName: PropTypes.string,
    })
  ).isRequired,
  reportTopTabClicked: PropTypes.func,
};

export default TopTabs;
